// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/utenti/selezionabili?societaId=${societaId}',
    requestBody: null,
    response: '{"success":"true","data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/insegne?societaId=${societaId}',
    requestBody: null,
    response: '{"insegne":"Insegna[]"}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?categoriaFornitore=AGENTE&societaId=${societaId}',
    requestBody: null,
    response: '{"data":"Nominativo[]"}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi/opzioni/condizioni-pagamento?societaId=${societaId}',
    requestBody: null,
    response: '{"success":"boolean","data":"CondizionePagamentoLite[]"}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi/opzioni/codici-iva?societaId=${societaId}',
    requestBody: null,
    response: '{"success":"boolean","data":"CodiceIvaLite[]"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/nominativi/:id/email/:id',
    requestBody: '{"etichetta":"string","email":"string","principale":"boolean","ambito":"string"}',
    response: '{"ok":"boolean"}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/email',
    requestBody: '{"etichetta":"string","email":"string","principale":"boolean","ambito":"string"}',
    response: '{"id":"number"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/nominativi/:id/email/:id',
    requestBody: null,
    response: '{"ok":"boolean"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/nominativi/:id/contatti/:id',
    requestBody: '{"nome":"string","cognome":"string","ruolo":"string","telefono":"string","cellulare":"string","email":"string","principale":"boolean","ambito":"string"}',
    response: '{"ok":"boolean"}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/contatti',
    requestBody: '{"nome":"string","cognome":"string","ruolo":"string","telefono":"string","cellulare":"string","email":"string","principale":"boolean","ambito":"string"}',
    response: '{"id":"number"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/nominativi/:id/contatti/:id',
    requestBody: null,
    response: '{"ok":"boolean"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/nominativi/:id/filiali/:id',
    requestBody: '{"nome":"string","via":"string","cap":"string","citta":"string","provincia":"string","paese":"string","note":"string","attivo":"boolean"}',
    response: '{"ok":"boolean"}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/filiali',
    requestBody: '{"nome":"string","via":"string","cap":"string","citta":"string","provincia":"string","paese":"string","note":"string","attivo":"boolean"}',
    response: '{"ok":"boolean"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/nominativi/:id/filiali/:id',
    requestBody: null,
    response: '{"ok":"boolean"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/nominativi/:id/cliente',
    requestBody: '{"categoriaCliente":"string","accountId":"number","insegnaClienteId":"number","agenteNominativoId":"number","condizionePagamentoId":"number","codiceIvaDefaultId":"number","iban":"string","abi":"string","cab":"string","banca":"string","filialeBanca":"string","note":"string"}',
    response: '{"ok":"boolean"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
